import { call, put } from 'redux-saga/effects';
import i18next from 'i18next';

import { API_HEADER_V1, apiCallWithApiKey } from '../services/api';
import {
  openAddReimbursementMethodModal,
  sendVerificationCodeFailed,
  sendVerificationCodeSuccess,
  verifyCodeAttempt,
  verifyCodeFailed,
  verifyCodeSuccess,
} from '../actions';
import {
  usePetCloudRequireSMSVerificationForSagas,
} from '../services/featureFlagsForSagas';
import { REIMBURSEMENT_METHODS } from '../constants';

export function* sendVerificationCode(dispatch, { payload }) {
  const errorGeneric = i18next.t('common:anErrorHasOccurred');

  try {
    const { email, phoneNumber } = payload;
    const useGenericError = false;
    // if true OTP flow use SMS else use email to validations
    const useOtpSms = yield usePetCloudRequireSMSVerificationForSagas();

    const options = {
      body: {
        Channel: useOtpSms ? 'sms' : 'email',
        ServiceName: 'Figo',
      },
      headers: API_HEADER_V1,
      method: 'POST',
    };

    if (useOtpSms) {
      options.body.PhoneNumber = phoneNumber;
    } else {
      options.body.Email = email;
    }

    const response = yield call(
      apiCallWithApiKey,
      'messaging/SendVerification',
      options,
      dispatch,
      useGenericError,
    );

    if (response?.success) {
      yield put(sendVerificationCodeSuccess());
    } else {
      const errorMessage = response?.message || errorGeneric;
      yield put(sendVerificationCodeFailed(errorMessage));
    }
  } catch (_) {
    yield put(sendVerificationCodeFailed(errorGeneric));
  }
}

export function* verifyCode(dispatch, { payload }) {
  try {
    const { code, email, phoneNumber } = payload;
    // OTP flow should validate by sms (email if turn off)
    const useOtpSms = yield usePetCloudRequireSMSVerificationForSagas();
    yield put(verifyCodeAttempt());

    const options = {
      body: {
        Channel: useOtpSms ? 'sms' : 'email',
        Code: code,
      },
      headers: API_HEADER_V1,
      method: 'POST',
    };

    if (useOtpSms) {
      options.body.PhoneNumber = phoneNumber;
    } else {
      options.body.Email = email;
    }

    const response = yield call(
      apiCallWithApiKey,
      'messaging/VerifyCode',
      options,
      dispatch,
    );

    if (response.success && response.status < 400) {
      yield put(verifyCodeSuccess(response?.verificationToken));
      yield put(openAddReimbursementMethodModal(REIMBURSEMENT_METHODS.check));
    } else {
      const errorMessage = response?.message;
      yield put(verifyCodeFailed(errorMessage));
    }
  } catch (error) {
    yield put(verifyCodeFailed(error?.message));
  }
}
